const styles = theme => {
  return {
    dateTimeWapper: {
      userSelect: 'none',

      [theme.breakpoints.up('sm')]: {
        fontSize: '16px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
      },
    },
    label: {
      fontSize: 'inherit',
      marginBottom: '12px',
      fontWeight: 500,
      pointerEvents: 'none',
      color: theme.palette.primary.adgmBlack,
      '& .MuiFormLabel-asterisk': {
        color: theme.palette.primary.errorRed,
      },
    },
    timePicker: {
      position: 'relative',
      display: 'flex !important',
      alignItems: 'center',
      paddingRight: '16px',
      gap: 8,
      maxHeight: '53.994px',
      border: `1px solid ${theme.palette.secondary.disableLightGray}`,
      borderRadius: '4px',
      overflow: 'hidden',

      // Input
      '& .rc-time-picker-input': {
        border: 'none',
        order: 0,
        padding: '16px',
        height: 'auto',
        fontSize: 'inherit',
        '&:active,&:focus': {
          outline: 'none',
        },
      },
      '& img': {
        cursor: 'pointer',
      },
    },
    pickerIsOpen: {
      borderColor: theme.palette.primary.adgmBlack,
    },
    clearTimeIcon: {
      order: 1,
      width: 16,
      height: 16,
    },
    timePickerIcon: {
      order: 2,
      width: 20,
      height: 20,
    },
    timePickerPopup: {
      '& .rc-time-picker-panel-inner': {
        display: 'flex',
        height: '270px',
        flexDirection: 'column',
        borderRadius: '10px',
        '& .rc-time-picker-panel-input-wrap': {
          padding: '10px 10px',
          fontSize: '16px',
          '&:focus': {
            outlineColor: theme.palette.primary.adgmBlack,
          },
          margin: '5px',
        },
      },
      '& .rc-time-picker-panel-select': {
        padding: '0px 8px 8px 8px',
        overflow: 'auto',
        width: 'auto',
        minHeight: '200px',
        '&::-webkit-scrollbar': {
          width: '4px',
          backgroundColor: 'white',
        },
        '&::-webkit-scrollbar-thumb': {
          background: theme.palette.primary.darkGrey,
          borderRadius: '4px',
        },
        '& ul': {
          background: theme.palette.primary.grey,
          '& li': {
            fontSize: '16px',
            padding: '4px 12px',
            height: 'auto',
            borderRadius: '4px',
            textTransform: 'uppercase',
            '&:hover': {
              backgroundColor: theme.palette.primary.borderColor,
            },
            '&.rc-time-picker-panel-select-option-selected': {
              backgroundColor: theme.palette.primary.adgmBlack,
              fontWeight: '500',
              color: 'white',
            },
          },
        },
      },
      '& .rc-time-picker-panel *': {
        height: '270px',
      },
    },
  };
};

export default styles;
